import { useSelector } from 'react-redux';
import { EnvTypeDTO } from '../types/ccson_env';
import { TileBasedGameFamilyType } from './tileGameConfig';
import { RootState } from 'reducers/store';
import { TileGameConfig } from '@envclient/envengine/src/envs/tilebase/TileGameConfig';

export interface GameFamily {
  name: string;
  type: TileBasedGameFamilyType;
  envType: EnvTypeDTO;
  src: string;
  title: string;
  games: TileGameConfig[];
}

const useGameFamilies = (): GameFamily[] => {
  const { ccsonGameConfigs, koenigsburgGameConfigs } = useSelector((state: RootState) => ({
    ccsonGameConfigs: state.gameConfigs.ccsonGameConfigs,
    koenigsburgGameConfigs: state.gameConfigs.koenigsburgGameConfigs
  }));
  return [
    {
      // chess removed from the UI for now (still fully implemented server/client-side, just not
      // selectable) - this slot takes its place in the grid with the Sea banner instead.
      type: 'sea',
      envType: 'ccson',
      src: 'sea_page_cover.png',
      title: 'Narrow Sea',
      name: 'narrowsea',
      games: ccsonGameConfigs.filter((gt) => gt.family === 'sea') as TileGameConfig[]
    },
    {
      type: 'koenigsburg',
      envType: 'koenigsburg',
      src: 'k_cover_resized.png',
      title: 'Koenigsbourg',
      name: 'koenigsburg',
      games: koenigsburgGameConfigs as TileGameConfig[]
    },
    {
      type: 'castle',
      envType: 'ccson',
      src: 'castle-tiles.png',
      title: 'Seven Castles',
      name: 'castles',
      games: ccsonGameConfigs.filter((gt) => gt.family === 'castle') as TileGameConfig[]
    },
    {
      type: 'ccson',
      envType: 'ccson',
      src: 'ccson_page_cover.png',
      title: 'Castle Zone',
      name: 'carcassonne',
      games: ccsonGameConfigs
        .filter((gt) => gt.family === 'ccson')
        .filter((g) => g.type !== 'fixed') as TileGameConfig[]
    }
  ];
};

export { useGameFamilies };
